import { ObjectValues } from 'types';

export const DOWNLOAD_BANNER_STATUS = {
  PREPARING: 'preparing',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type DownloadBannerStatus =
  | ObjectValues<typeof DOWNLOAD_BANNER_STATUS>
  | null;
